import _ from 'lodash';
import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withFirebase} from 'react-redux-firebase';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from 'assets/jss/material-kit-react/views/loginPage.jsx';
import chalk1080 from "assets/img/background/chalk1080.jpg"
import {SIGNUP_FIELDS} from './formFields';
// TODO validation doesnt actually do anything? firebase checks email already used also...
// import asyncValidate from './asyncValidate';
import SocialMediaLogin from "components/SocialLogins/SocialLogins.jsx"
import {createNewFirebaseUser, logoutUser, resetErrorAfterPrompt} from '../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';

class SignUpPage extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden"
    };
  }

  componentDidMount() {
    this.props.resetErrorAfterPrompt();
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      500
    );
    //TODO remove this later, need to setup redirect if already logged in?
    this.props.logoutUser();
  }

  async onFormSubmit(values) {
    const {name, email, password} = values;
    const {history, createNewFirebaseUser} = this.props;
    createNewFirebaseUser(email.trim(), password, name.trim(), history);
  }

  renderTextField(field) {
    return (
      <TextField
        id={field.name}
        label={field.label}
        fullWidth
        required
        margin='normal' // 'none' | 'dense' | 'normal'
        InputProps={{
          type: field.inputType,
          endAdornment: (
            <InputAdornment position="end">
              <field.iconType className={field.iconClassName} />
            </InputAdornment>
          )
        }}
        {...field.input}
        {...field.custom}
      />
    );
  }

  renderLoginForm() {
    const {classes, handleSubmit, reset, profile, resetErrorAfterPrompt} = this.props;
    if (profile.loading) {
      return <LoadingSpinner />;
    } else if (profile.error) {
      alert(profile.error);
      resetErrorAfterPrompt();
    }

    return (
      <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))} className={classes.form}>
        <p className={classes.divider}>Already signed up? <a href="/user/login">Log in</a></p>
        <br />
        <p className={classes.signupHelper}>Sign up to track polls you answer, create and share with pals.</p>
        <p className={classes.signupHelper}>Follow pals to send messages and see your total number of matching answers.</p>
        <SocialMediaLogin />
        <CardBody>
          {_.map(SIGNUP_FIELDS, (field, fname) => {
            return (
              <Field
                label={field.label}
                name={fname}
                key={fname}
                inputType={field.inputType}
                iconType={field.iconType}
                iconClassName={classes.inputIconsColor}
                component={this.renderTextField}
              />
            );
          })}
        </CardBody>
        <CardFooter className={classes.cardFooter}>
          <Button color="primary" size="lg" type="submit">
            Get started
          </Button>
          <p>{"\n"}</p>
          <Button simple color="primary" size="lg" onClick={reset}>
            Clear
          </Button>
        </CardFooter>
      </form>
    );
  }

  render() {
    const {classes, handleSubmit, reset, ...rest} = this.props;

    return (
      <div>
        <Header
          color="white"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + chalk1080 + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} md={8} lg={6}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h3>Create a New Account</h3>
                  </CardHeader>
                  {this.renderLoginForm()}
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          <Footer whiteFont />
        </div>
      </div>
    );
  }
}

// TODO QUESTION should I add validation? or make user confirm email??
// function validate(values) {
//   const errors = {};
//
//   _.each(SIGNUP_FIELDS, (finfo, field) => {
//     if (!values[field]) {
//       errors[field] = 'Required field';
//     }
//   });
//
//   if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
//    errors.email = 'Invalid email address';
//   }
//
//   return errors;
// }

function mapStateToProps(state) {
  return {profile: state.profile};
}

const pageWithStylesAndFirebase = withStyles(loginPageStyle)(withFirebase(SignUpPage));

export default reduxForm({
  form: 'LoginForm',
  // asyncValidate,
})(
  withRouter(connect(mapStateToProps, {createNewFirebaseUser, logoutUser, resetErrorAfterPrompt})(pageWithStylesAndFirebase))
);



// WEBPACK FOOTER //
// ./src/views/SignUpPage.js